<style scoped>
tr:nth-child(odd) {
  background: #f6f6f6;
}
</style>

<template>
  <v-layout xs12 column wrap>
    <v-layout align-center justify-space-between row>
      <v-flex xs5 sm6 pa-4>
        <v-text-field
          v-model="search"
          prepend-icon="search"
          label="Search"
          hide-details
        ></v-text-field>
      </v-flex>
      <v-flex xs4 md3 lg2 pa-4 justify-end>
        <customer-add></customer-add>
      </v-flex>
    </v-layout>

    <v-flex xs12>
      <v-alert
        v-if="alert"
        :value="!loading"
        :type="alert.type"
        v-html="alert.message"
      ></v-alert>
      <v-data-table
        :headers="headers"
        :items="mappedItems"
        :search="search"
        :must-sort="true"
        :loading="loading"
        class="elevation-0"
        :hide-actions="hideActions"
        :pagination.sync="pagination"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template v-slot:items="{ item: address }">
          <tr>
            <td>{{ address.number }}</td>
            <td>
              <address-name-format
                :names="[address.name1, address.name2, address.name3]"
              ></address-name-format>
            </td>
            <td>{{ address.clientLabel }}</td>
            <td>{{ address.customizationLabel }}</td>
            <td>{{ address.country }}</td>
            <td>
              <customer-edit :customer="address"></customer-edit>
            </td>
            <td>
              <v-btn
                @click="openDetail(address.id)"
                class="ma-0"
                color="blue"
                outline
                small
              >
                <v-icon small class="pr-1">person</v-icon>
                Users
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import AddressNameFormat from "@/components/AddressNameFormat.vue";
import CustomerEdit from "@/components/CustomerEdit.vue";
import CustomerAdd from "@/components/CustomerAdd.vue";

const paginationRowsPerPage = -1;

export default {
  components: {
    AddressNameFormat,
    CustomerEdit,
    CustomerAdd
  },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "No.",
          value: "number"
        },
        {
          text: "Name",
          value: "name"
        },
        {
          text: "Client",
          value: "clientId"
        },
        {
          text: "Configuration",
          value: "customization"
        },
        {
          text: "Country",
          value: "country"
        },
        {
          text: "",
          value: "",
          sortable: false
        },
        {
          text: "",
          value: "",
          sortable: false
        }
      ],
      pagination: {
        rowsPerPage: paginationRowsPerPage
      },
      rowsPerPageItems: [10, 25, 50, { text: "All", value: -1 }]
    };
  },
  computed: {
    ...mapGetters("admin", {
      customers: "getCustomerList"
    }),
    ...mapState("admin", ["alert", "loading"]),
    mappedItems() {
      return this.customers.map(item => {
        return {
          ...item,
          name: `${item.name1} ${item.name2} ${item.name3}`
        };
      });
    },
    hideActions() {
      return !this.customers || this.customers.length <= paginationRowsPerPage;
    }
  },
  methods: {
    openDetail(customerId) {
      this.$router.push({
        name: "customer_detail",
        params: { customerId }
      });
    },
    onDelete(id) {
      this.$store.dispatch("admin/deleteCustomer", {
        id,
        collection: this.collection
      });
    }
  },
  mounted() {
    this.$store.dispatch("admin/fetchCustomerList");
  },
  watch: {
    alert(alert) {
      if (alert && alert.message) {
        setTimeout(() => {
          this.$store.commit("admin/setAlert", null);
        }, 3000);
      }
    }
  }
};
</script>
